"use client"
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { useMediaQuery } from "react-responsive";

import CommunityDirectoryMemberView from "@/components/communities/CommunityDirectoryMemberView";
import "@/components/communities/CommunityDirectoryMapAndPins.css";

import "@/components/communities/CommunityDirectoryList.css";
import CommunityDirectoryPointFilterv2 from "@/components/communities/CommunityDirectoryPointFilterv2";

const CommunityDirectoryList = ({
  currentLocation,
  community,
  points,
  types,
  showCoverPhoto = false,
  showSearchFilter = true,
  showOpenNow = true
}) => {
  const [mapPoints, setMapPoints] = useState(null);
  const [filteredPoints, setFilteredPoints] = useState(null);

  const isSm = useMediaQuery({ maxWidth: 767.98 });

  useEffect(() => {
    if (points && points.length > 0) {
      let newMapPoints = [];
      points.forEach(mapPoint => {
        mapPoint.userProfile["location"] = mapPoint.location;
        newMapPoints.push(mapPoint);
      });
      setMapPoints(newMapPoints.sort((a, b) => a.userProfile.displayName.localeCompare(b.userProfile.displayName)));
    }
  }, [points]);

  if (mapPoints) {
    return (
      <div className="community-directory-list">
        {showSearchFilter && (
          <div className="community-directory-filter">
            <CommunityDirectoryPointFilterv2
              community={community}
              points={mapPoints}
              types={types}
              basic={false}
              showOpenNow={showOpenNow}
              onSelect={filteredPoints => {
                if (filteredPoints) {
                  setFilteredPoints(filteredPoints);
                } else {
                  setFilteredPoints(null);
                }
              }}
            />
          </div>
        )}
        <div className="community-directory-entries">
          {filteredPoints && filteredPoints.length === 0 && (
            <div
              className="center-child-div-parent"
              style={{ paddingTop: "2rem", flex: 1 }}
            >
              <p style={{ fontSize: "1.125rem" }}>No results to display</p>
            </div>
          )}
          {mapPoints.map(function(mapPoint, index) {
            var className = filteredPoints
              ? filteredPoints.findIndex(pt => pt.id === mapPoint.id) === -1
                ? "hide"
                : ""
              : "";
            return (
              <CommunityDirectoryMemberView
                className={className}
                id={mapPoint.id}
                key={`${mapPoint.id}-${index}`}
                community={community}
                profile={mapPoint.userProfile}
                coordinates={currentLocation}
                external={false}
                showMap={false}
                showCoverPhoto={showCoverPhoto}
              />
            );
          })}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
export default CommunityDirectoryList;
